<app-auth-layout>
    <div class="cont">
        <img class="logo" src="./assets/images/logo.svg" />
        <p>
            Processing your details... <sync-icon name="upload-inprogress"></sync-icon>
        </p>
    </div>
</app-auth-layout>